import { LineSeparator } from '@/components/LineSeparator';
import { AuthUserProfileAvatar } from '@/partials/dashboard/Users/AuthUserProfile/AuthUserProfileAvatar';
import { AuthUserProfileInformations } from '@/partials/dashboard/Users/AuthUserProfile/AuthUserProfileInformations';

export const AuthUserProfile = () => {
  return (
    <>
      <AuthUserProfileAvatar />
      <LineSeparator className="my-8" />
      <AuthUserProfileInformations />
    </>
  );
};
